
import Button from "@/components/base/Button"

import Swiper, { Pagination, Navigation } from "swiper"
import "swiper/swiper.scss"
import "swiper/modules/pagination/pagination.scss"

import { mapState } from "vuex"
import { mdiClose, mdiChevronLeft, mdiChevronRight } from "@mdi/js"

export default {
    name: "ImageCarousel",
    components: { Button },
    props: {
        title: String,
        logoUrl: String,
        mainImages: Array,
        galleryImages: Array,
        motto: String,
    },
    icons: {
        mdiClose,
        mdiChevronLeft,
        mdiChevronRight,
    },
    data() {
        return {
            sliderDialog: false,
            carouselIndex: null,
        }
    },
    mounted() {
        new Swiper(this.$refs["swiper"], {
            modules: [Pagination, Navigation],
            navigation: {
                nextEl: `.swiper-button-next`,
                prevEl: `.swiper-button-prev`,
            },
        })
    },
    computed: {
        ...mapState("business", ["displayedProfile"]),
        isSingleImage() {
            return this.$breakpoint.smAndDown || this.allImages.length < 2
        },
        isDoubleImage() {
            return (
                !this.$breakpoint.smAndDown &&
                this.allImages.length >= 2 &&
                (this.allImages.length < 5 || !this.$breakpoint.lgAndUp)
            )
        },
        isPentaImage() {
            return (
                !this.$breakpoint.smAndDown &&
                this.allImages.length >= 5 &&
                this.$breakpoint.lgAndUp
            )
        },
        imageDescription() {
            if (
                this.carouselIndex !== null &&
                this.allImages[this.carouselIndex]
            ) {
                return this.allImages[this.carouselIndex].description
            }
            return ""
        },
        imageCopyright() {
            if (
                this.carouselIndex !== null &&
                this.allImages[this.carouselIndex]
            ) {
                return this.allImages[this.carouselIndex].copyright
            }
            return ""
        },
        allImages() {
            if (this.mainImages == undefined) {
                return []
            }
            return this.mainImages.concat(this.galleryImages)
        },
    },
    methods: {
        openFullscreen(index) {
            if (this.getImagePath(0) !== this.logoUrl) {
                this.carouselIndex = index
                this.sliderDialog = true
            }
        },
        getImagePath(index) {
            if (index > 4) {
                return false
            }
            if (this.allImages != undefined && index in this.allImages) {
                return this.$getImage({
                    image: this.allImages[index],
                    preferedSize: "1",
                }).src
            } else {
                return false
            }
        },
        getImagePlaceholderPath(index) {
            if (index > 4) {
                return false
            }
            if (this.allImages != undefined && index in this.allImages) {
                return this.$getImage({
                    image: this.allImages[index],
                    preferedSize: "p",
                }).src
            } else {
                return false
            }
        },
        getImagePathByImage(image) {
            return this.$getImage({ image: image, preferedSize: "1" }).src
        },
        getMobileImage(image) {
            return this.$getImage({
                image: image,
                preferedSize: "1",
            })
        },
    },
}
